if (!customElements.get('top-header-search-btn')) {
  customElements.define(
      'top-header-search-btn',
      class TopHeaderSearchBtn extends HTMLElement {
        constructor() {
          super();

          this.btn = this.querySelector('.top-header__searchBtn');
          this.headerSearchDetail = document.querySelector('.header__search details');
          this.headerSearch = document.querySelector('.header__search');

          this._onBtnClick = this._onBtnClick.bind(this);
          this.onBodyClick = this.onBodyClick.bind(this);
          this.open = this.open.bind(this);
          this.close = this.close.bind(this);

          this.init();
        }

        init(){
          this._bindEvents();
        }

        isOpen() {
          return this.headerSearchDetail.hasAttribute('open');
        }

        _bindEvents(){
          if( this.btn && this.headerSearchDetail ){
            this.btn.addEventListener('click', this._onBtnClick.bind(this));
          } 
        }

        _onBtnClick(event){
          event.preventDefault();
          this.headerSearchDetail.hasAttribute('open') ? this.close() : this.open();
        }

        onBodyClick(event) {
          if (event.target.classList.contains('modal-overlay')) this.close(false);
        }

        open() {
          this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
          this.headerSearchDetail.setAttribute('open', true);
          document.body.addEventListener('click', this.onBodyClickEvent);
          document.body.classList.add('overflow-hidden');

          trapFocus(
            this.headerSearchDetail.querySelector('[tabindex="-1"]'),
            this.headerSearchDetail.querySelector('input:not([type="hidden"])')
          );
        }

        close(focusToggle = true) {
          removeTrapFocus(focusToggle ? this.summaryToggle : null);
          if (this.headerSearchDetail) {
            this.headerSearchDetail.removeAttribute('open');
          }
          
          document.body.removeEventListener('click', this.onBodyClickEvent);
          document.body.classList.remove('overflow-hidden');
        }
      }
  );
};